import { makeStyles } from '@mui/styles';

export const useSearchSelectStyles = makeStyles({
  option: {
    fontSize: '14px',
  },
  noOptions: {
    fontSize: '14px',
  },
});
